/**
 * Labstep
 *
 * @module components/Molecule/Safety/Pictograms
 * @desc Showing molecule safety pictograms
 */

import classnames from 'classnames';
import { MoleculeSafetyActionAdd as ActionAdd } from 'labstep-web/components/Molecule/Safety/ActionAdd';
import { MoleculeSafetyActionRemove as ActionRemove } from 'labstep-web/components/Molecule/Safety/ActionRemove';
import { hazardClassPictograms } from 'labstep-web/components/Molecule/Safety/constants';
import { Header } from 'labstep-web/core/Header';
import { Hoverable } from 'labstep-web/core/Hoverable';
import { PopupContainer as Popup } from 'labstep-web/core/Popup';
import type React from 'react';
import { Image } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { MoleculeSafetyPictogramsProps } from './types';

export const MoleculeSafetyPictograms: React.FC<
  MoleculeSafetyPictogramsProps
> = ({ parent, pubChemMetadata, isInline, size }) => {
  const { pictograms } = pubChemMetadata.Safety;
  return (
    <div
      className={classnames({
        [styles.container]: isInline,
      })}
    >
      {!isInline && <Header size="mini">Pictograms</Header>}
      <div
        className={classnames(styles.pictograms, {
          [styles.inline]: isInline,
        })}
      >
        {(pictograms || []).map((h) => {
          const pictogram =
            hazardClassPictograms[
              h as keyof typeof hazardClassPictograms
            ];
          if (!pictogram) {
            return null;
          }
          return (
            <Popup
              key={h}
              trigger={
                // Need to wrap in div otherwise popup doesn't show
                <div className={styles.container}>
                  <Hoverable
                    component={
                      parent && (
                        <ActionRemove
                          code={h}
                          pubChemMetadata={pubChemMetadata}
                          type="pictograms"
                          parent={parent}
                        />
                      )
                    }
                    hoverable={
                      <Image size={size} inline src={pictogram.src} />
                    }
                  />
                </div>
              }
              content={pictogram.additional.join(', ')}
            />
          );
        })}
      </div>
      {parent && (
        <ActionAdd
          pubChemMetadata={pubChemMetadata}
          type="pictograms"
          parent={parent}
        />
      )}
      <br />
    </div>
  );
};
